<script>
	import { beforeUpdate, onMount } from 'svelte';
    import { push } from "svelte-spa-router";
    import {data} from "../store";
    import {fade} from 'svelte/transition';

    onMount(()=>{
        if ($data.local == undefined || $data.local == ""){
            push('/');
        }
    })
    let etapa=0;
    let artista = "";
    let tipo = "tatuaje";
    let respuesta = "";
    let fecha = new Date();
    let documentoTatuaje  ={//15
		nombre: "Tatuaje",
		texto: [
			"He leído y entendido toda la información , la cual es de vital importancia, para el cuidado y tratamiento del tatuaje a realizar.",
			"Por la presente declaro que participe en la elección del diseño de dicho tatuaje,tanto en:",
			"· Su composición (Tamaño, Forma, Color);",
			"· Elección del lugar del cuerpo, sabiendo que la piel es un órgano elástico y con el movimiento natural del cuerpo se podría ver afectada su forma;",
			"Asi mismo digo que:",
			"·        No estoy bajo ningún tratamiento médico, ni padezco ninguna condición médica que me impida realizarme un tatuaje;",
			"·        No estoy bajo la influencia de alcohol o drogas en el momento de realizar el tatuaje;",
			"·        Entiendo que puede existir riesgo de infección ante la falta de la higiene recomendada, piel sensible u otras causas.",
			"·      No estoy atravesando un embarazo",
			"·      No padezco ninguna ETS",
			"La gran mayoría de los casos se deben a la falla en seguir cuidadosamente los procedimientos de curado.",
			"·        Acepto haber escuchado los cuidados del curado del tatuaje que me proporcionaron en ARTE A FLOR DE PIEL.",
			"·        Por lo tanto, me comprometo a seguir los procedimientos del curado.",
			"Afirmo ser mayor de 18 años de edad;",
			"Lugar y Diseño del tatuaje",
			""
		]
	};
    let documentoPerfo = {//9
        nombre: "Perforación",
		texto: [
			"He leído y entendido toda la información, la cual es de vital importancia para el cuidado y tratamiento del piercing a realizar.",
			"Fui informado y es totalmente visible la utilización de material absolutamente descartable y esterilizado.",
			"Así mismo digo que:",
			"· No padezco ninguna afección cutánea o alergias conocidas por mi o mi dermatólogo.",
			"· Comprendo que, si cambiase el método de cicatrización sugerido por ARTE A FLOR DE PIEL, los tiempos y la forma de la cicatrización podrían variar.",
			"· Entiendo los tiempos de cicatrización del lugar del cuerpo donde se colocará la pieza.",
			"· Soy consciente, que puede existir riesgo de infección ante la falta de la higiene recomendada, piel sensible u otras causas. La gran mayoría de los casos se deben a la falla en seguir cuidadosamente los procedimientos de curado.",
			"Soy mayor de 18 años de edad, de no ser así, estoy acompañado de mí: Padre, Madre, Tutor Legal.",
			"Lugar y Aro Colocado",
			""
		]
    }
    function siguiente(){
        etapa++;
        if (etapa==1){
            if (tipo == "tatuaje"){
                documentoTatuaje.texto[15] = respuesta;
                documentoTatuaje.fecha = fecha;
                $data.respuestas.push(documentoTatuaje);
            } else {
                documentoPerfo.texto[9] = respuesta;
                documentoPerfo.fecha = fecha;
                $data.respuestas.push(documentoPerfo);
            }
            if (respuesta != undefined && respuesta !== ""){
                $data.empleado = artista;
                push("/firma");
            }
        }
    }
    function tatuaje(){
        // etapa = 1;
        tipo = "Tatuaje";
        $data.service = "Tatuaje";
    }
    function perforacion(){
        tipo = "perforacion";
        $data.service = "Perforación";
        // etapa = 1;
    }

    /*
    {:else if etapa == 1}
            {#if tipo == "tatuaje"}
            <div class="w-full h-2/5 overflow-hidden overflow-y-scroll  border-b-2 border-red-500 shadow-inner"  in:fade="{{duration: 500}}">
                    <div class="flex items-center justify-center w-full p-4">
                    He leído y entendido toda la información , la cual es de vital importancia, para el cuidado y tratamiento del tatuaje a realizar.
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    Por la presente declaro que participe en la elección del diseño de dicho tatuaje,tanto en:
                    </div>
                    <div class="flex font-bold items-center justify-center w-full p-4">
                    · Su composición (Tamaño, Forma, Color);
                    </div>
                    <div class="flex font-bold items-center justify-center w-full p-4">
                    · Elección del lugar del cuerpo, sabiendo que la piel es un órgano elástico y con el movimiento natural del cuerpo se podría ver afectada su forma;
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    Asi mismo digo que:
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    ·        No estoy bajo ningún tratamiento médico, ni padezco ninguna condición médica que me impida realizarme un tatuaje;
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                        ·        No estoy bajo la influencia de alcohol o drogas en el momento de realizar el tatuaje;
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    ·        Entiendo que puede existir riesgo de infección ante la falta de la higiene recomendada, piel sensible u otras causas.
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    ·      No estoy atravesando un embarazo
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    ·      No padezco ninguna ETS
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    La gran mayoría de los casos se deben a la falla en seguir cuidadosamente los procedimientos de curado.
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    ·        Acepto haber escuchado los cuidados del curado del tatuaje que me proporcionaron en ARTE A FLOR DE PIEL.
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    ·        Por lo tanto, me comprometo a seguir los procedimientos del curado.
                    </div>
                    <div class="flex items-center justify-center w-full p-4">
                    Afirmo ser mayor de 18 años de edad;
                    </div>
                </div>
            {:else}
                <div class="w-full h-2/5 overflow-hidden overflow-y-scroll border-b-2 border-red-500 shadow-inner"  in:fade="{{duration: 500}}">
                        <div class="flex items-center justify-center w-full p-4">
                        He leído y entendido toda la información, la cual es de vital importancia para el cuidado y tratamiento del piercing a realizar.
                        </div>
                        <div class="flex font-bold items-center justify-center w-full p-4">
                        Fui informado y es totalmente visible la utilización de material absolutamente descartable y esterilizado.
                        </div>
                        <div class="flex items-center justify-center w-full p-4">
                        Así mismo digo que:
                        </div>
                        <div class="flex items-center justify-center w-full p-4">
                        · No padezco ninguna afección cutánea o alergias conocidas por mi o mi dermatólogo.
                        </div>
                        <div class="flex items-center justify-center w-full p-4">
                        · Comprendo que, si cambiase el método de cicatrización sugerido por ARTE A FLOR DE PIEL, los tiempos y la forma de la cicatrización podrían variar.
                        </div>
                        <div class="flex items-center justify-center w-full p-4">
                        · Entiendo los tiempos de cicatrización del lugar del cuerpo donde se colocará la pieza.
                        </div>
                        <div class="flex items-center justify-center w-full p-4">
                        · Soy consciente, que puede existir riesgo de infección ante la falta de la higiene recomendada, piel sensible u otras causas. La gran mayoría de los casos se deben a la falla en seguir cuidadosamente los procedimientos de curado.
                        </div>
                        <div class="flex items-center justify-center w-full p-4">
                        Soy mayor de 18 años de edad, de no ser así, estoy acompañado de mí: Padre, Madre, Tutor Legal.
                        </div>                        
                </div>
            {/if}
    */
</script>
<div class="w-full h-screen flex flex-col items-center justify-start w-full h-full p-4" in:fade="{{duration: 500}}">
    <div class="w-full grid grid-cols-3 grid-row-auto">
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-red-500 shadow text-white rounded-full flex items-center justify-center">1</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">2</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">3</div>
        </div>
    </div>
    <div class="w-full grid grid-cols-3 grid-row-auto text-xs text-center">
        <div class="flex flex-col items-center justify-start">
            Datos Personales
        </div>
        <div class="flex flex-col items-center justify-start">
            Servicio
        </div>
        <div class="flex flex-col items-center justify-start">
            Firma
        </div>
    </div>
    <div class="w-full h-screen flex flex-col items-center justify-start pt-8">
        {#if etapa == 0}
        <h1 class="w-full text-center text-xl font-bold mb-2">Elegir que es lo que se va a realizar</h1>
        <div class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full" on:click={tatuaje}>Tatuaje</div>
        <div class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full" on:click={perforacion}>Perforación</div>
            <div class="w-full text-center font-bold mt-2">¿Qué te vas a hacer y dónde?</div>
            <input bind:value={respuesta} placeholder={(tipo == "tatuaje"?"Ej: Dragon en la espalda.":"Ej: Aro en la oreja.")} type="text" class="m-2 p-2 w-full bg-white rounded shadow" />
            <div class="w-full text-center font-bold mt-2">¿Con qué artista lo vas a realizar?</div>
            <input bind:value={$data.artista} placeholder={(tipo == "tatuaje"?"Ej: Felino.":"Ej: Santy.")} type="text" class="m-2 p-2 w-full bg-white rounded shadow" />
            <div class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full" on:click={siguiente}>He leído y acepto los términos y condiciones</div>
        {/if}
    </div>
</div>
